<h1 mat-dialog-title>Eingaben wirklich entfernen?</h1>
<mat-dialog-content>Diese Aktion kann nicht rückgängig gemacht werden! Bitte vergewissern Sie sich, dass Sie die
    Eingaben tatsächlich verwerfen wollen.</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>abbrechen</button>
    <button mat-button color="primary" [mat-dialog-close]="true">ja, entfernen</button>
</mat-dialog-actions>